import React from 'react';
import { Mail, MapPin, Instagram, Facebook, Twitter, Phone } from 'lucide-react';
import { companyInfo } from '../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (sectionId) => {
    document.getElementById(sectionId)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-black border-t border-amber-500/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand Column */}
          <div className="lg:col-span-2 animate-fadeInUp">
            <div className="flex items-center gap-3 mb-6 group cursor-pointer" onClick={() => scrollToSection('hero')}>
              <img
                src={companyInfo.logo}
                alt={companyInfo.name}
                className="h-14 w-14 object-contain rounded-lg transition-all duration-300 group-hover:scale-110 group-hover:shadow-[0_0_20px_rgba(212,160,23,0.4)]"
              />
              <span className="text-xl font-bold text-gold-gradient">
                {companyInfo.name}
              </span>
            </div>
            <p className="text-gray-400 mb-6 max-w-md leading-relaxed">
              Experience luxury car rentals in the Greater Toronto Area. 
              From exotic supercars to premium SUVs, we have the perfect vehicle for every occasion.
            </p>
            <div className="flex items-center gap-3">
              {[Instagram, Facebook, Twitter].map((Icon, index) => (
                <a
                  key={index}
                  href="#"
                  className="w-10 h-10 bg-gray-900 hover:bg-amber-500/20 border border-gray-800 hover:border-amber-500/50 rounded-lg flex items-center justify-center transition-all duration-300 group hover:scale-110"
                >
                  <Icon className="w-5 h-5 text-gray-400 group-hover:text-amber-400 transition-colors" />
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div className="animate-fadeInUp animation-delay-200">
            <h4 className="text-white font-semibold mb-6">Quick Links</h4>
            <ul className="space-y-3">
              {[
                { name: 'Home', id: 'hero' },
                { name: 'Our Fleet', id: 'fleet' },
                { name: 'About Us', id: 'about' },
                { name: 'Reviews', id: 'reviews' },
                { name: 'Contact', id: 'inquiry' }
              ].map((link) => (
                <li key={link.id}>
                  <button
                    onClick={() => scrollToSection(link.id)}
                    className="text-gray-400 hover:text-amber-400 transition-colors link-underline"
                  >
                    {link.name}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div className="animate-fadeInUp animation-delay-300">
            <h4 className="text-white font-semibold mb-6">Contact Us</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3 group">
                <div className="w-10 h-10 bg-amber-500/10 rounded-lg flex items-center justify-center flex-shrink-0 group-hover:bg-amber-500/20 transition-colors">
                  <Phone className="w-5 h-5 text-amber-400" />
                </div>
                <div>
                  <p className="text-sm text-gray-500">Call us at</p>
                  <a
                    href={`tel:${companyInfo.phone.replace(/-/g, '')}`}
                    className="text-gray-300 hover:text-amber-400 transition-colors font-medium"
                  >
                    {companyInfo.phone}
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-3 group">
                <div className="w-10 h-10 bg-amber-500/10 rounded-lg flex items-center justify-center flex-shrink-0 group-hover:bg-amber-500/20 transition-colors">
                  <Mail className="w-5 h-5 text-amber-400" />
                </div>
                <div>
                  <p className="text-sm text-gray-500">Email us at</p>
                  <a
                    href={`mailto:${companyInfo.email}`}
                    className="text-gray-300 hover:text-amber-400 transition-colors text-sm break-all"
                  >
                    {companyInfo.email}
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-3 group">
                <div className="w-10 h-10 bg-amber-500/10 rounded-lg flex items-center justify-center flex-shrink-0 group-hover:bg-amber-500/20 transition-colors">
                  <MapPin className="w-5 h-5 text-amber-400" />
                </div>
                <div>
                  <p className="text-sm text-gray-500">Location</p>
                  <span className="text-gray-300 text-sm">
                    Greater Toronto Area, Ontario, Canada
                  </span>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-gray-900">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
            <p className="text-gray-600 text-sm">
              © {currentYear} {companyInfo.name}. All rights reserved.
            </p>
            <div className="flex items-center gap-6 text-sm">
              <a href="#" className="text-gray-600 hover:text-amber-400 transition-colors">
                Privacy Policy
              </a>
              <a href="#" className="text-gray-600 hover:text-amber-400 transition-colors">
                Terms of Service
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
